import styled, { css } from "styled-components";

import media from "../../styles/media";
import {
  flexHelpers,
  marginHelpers,
  paddingHelpers,
} from "../../styles/positioning";

const ContainerStyles = css`
  ${flexHelpers} ${({ section }) =>
    section
      ? css`
          padding-top: ${({ theme }) => `calc(${theme.padding.base} * 5)`};
          padding-bottom: ${({ theme }) => `calc(${theme.padding.base} * 5)`};
        `
      : ``};

  width: 100%;

  ${({ fixed }) =>
    fixed
      ? css`
          padding-left: ${({ theme }) => `calc(${theme.padding.base} * 2)`};
          padding-right: ${({ theme }) => `calc(${theme.padding.base} * 2)`};
          margin: 0 auto;

          ${media.sm`
      padding-left: 0;
      padding-right: 0;
      width: ${({ theme }) => theme.containerSizes.sm};
      `}

          ${media.md`
      width: ${({ theme }) => theme.containerSizes.md};
      `}

    ${media.lg`
      width: ${({ theme }) => theme.containerSizes.lg};
      `}

    ${media.xl`
      width: ${({ theme }) => theme.containerSizes.xl};
      `}
        `
      : ``};

  ${marginHelpers} ${paddingHelpers};
`;

const Container = ({ children, ...rest }) => {
  const element = rest.section ? "section" : "div";
  const Wrapper = styled(element)`
    ${ContainerStyles};
  `;
  return <Wrapper {...rest}>{children}</Wrapper>;
};

Container.displayName = "Container";

// eslint-disable-next-line
export default Container;
